var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 38,
    viewBox: "0 0 43 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 38,
    width: 10,
    height: 38,
    transform: "rotate(-180 10 38)",
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 20.7321C6.66667 19.9623 6.66667 18.0378 8 17.268L30.5 4.27757C31.8333 3.50777 33.5 4.47002 33.5 6.00962L33.5 31.9904C33.5 33.53 31.8333 34.4922 30.5 33.7224L8 20.7321Z",
    fill: "#D9D9D9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart);
export default __webpack_public_path__ + "static/media/start.c035038e154761c83f6b70d27a5a07c4.svg";
export { ForwardRef as ReactComponent };